"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.isStringSuccessResponse = isStringSuccessResponse;
exports.isSuccessResponse = isSuccessResponse;
var _ApiGroup = _interopRequireDefault(require("./ApiGroup"));
var _chains = require("@blockwell/chains");
function isSuccessResponse(response) {
  return "data" in response;
}
function isStringSuccessResponse(response) {
  return "data" in response && typeof response.data === "string";
}
class Contracts extends _ApiGroup.default {
  /**
   * Find a Contract by network and address
   */
  find(address, network) {
    let params = {
      address
    };
    if (network) {
      params.network = network;
    }
    return this.request({
      url: "/contracts",
      params
    }).then(response => response.data.data);
  }
  search(text, network) {
    let params = {
      text
    };
    if (network) {
      params.network = network;
    }
    return this.request({
      url: "/contracts",
      params
    }).then(response => response.data.data);
  }

  /**
   * Query for a list of contracts.
   * @param queries List of contracts to retrieve
   */
  query(queries) {
    return this.request({
      url: "/contracts?id=" + queries.map(it => {
        if (typeof it === "string") {
          return it;
        } else {
          return (0, _chains.toChainId)(it.chainId) + "." + it.address;
        }
      }).join(",")
    }).then(response => response.data.data);
  }

  /**
   * Adds an existing smart contract to API Miner.
   *
   * @param  name Name of the contract
   * @param network Ethereum network the contract is on
   * @param  address Address of the contract
   * @param abiSource Either the ABI itself as an array, or a smart contract type name in API Miner
   * @param  fromBlock The first block this contract is present in
   */
  add(name, network, address, abiSource, fromBlock) {
    let data = {
      name,
      network,
      address,
      fromBlock
    };
    if (Array.isArray(abiSource)) {
      data.abi = abiSource;
    } else if (typeof abiSource === "string") {
      data.type = abiSource;
    } else {
      throw new Error("abiSource must either be an ABI array or a type string");
    }
    return this.request({
      method: "put",
      url: "/contracts",
      data
    }).then(response => response.data.data);
  }

  /**
   * Get a specific Contract by its ID.
   *
   * @param  id
   */
  get(id) {
    return this.request({
      url: `/contracts/${id}`
    }).then(response => response.data.data);
  }

  /**
   * Make a view-only contract call.
   *
   * @param id Contract ID
   * @param method Contract function
   * @param  arg Function arguments
   */
  call(id, method, arg = []) {
    return this.request({
      url: `/contracts/${id}/call/${method}`,
      params: {
        arg: arg
      }
    }).then(response => response.data.data);
  }

  /**
   * Make a batch of view-only contract calls.
   *
   * @param  calls Batch of calls
   */
  batchCall(calls) {
    return this.request({
      method: "post",
      url: `/contracts/call`,
      data: {
        calls: calls
      }
    }).then(response => response.data.data);
  }

  /**
   * Make a transactional contract call.
   */
  send(id, method, arg, opt = {}) {
    let data = Object.assign({}, opt);
    if (arg) {
      data.arg = arg;
    }
    return this.request({
      method: "post",
      url: `/contracts/${id}/send/${method}`,
      data: data
    }).then(response => response.data.data);
  }

  /**
   * Make a contract send directly to chain without a contract ID.
   *
   * @param network
   * @param  address
   * @param type Name of the contract type, eg. erc20
   * @param  method Contract function
   * @param arg Function arguments
   * @param from From account
   */
  direct(network, address, type, method, arg, from) {
    let data = {
      type
    };
    if (arg) {
      data.arg = arg;
    }
    if (from) {
      data.from = from;
    }
    return this.request({
      method: "post",
      url: `/contracts/direct/${network}/${address}/send/${method}`,
      data: data
    }).then(response => response.data.data);
  }

  /**
   * Make a direct view-only contract call.
   *
   * @param  network
   * @param  address
   * @param  type Name of the contract type, eg. erc20
   * @param  method Contract function
   * @param  arg Function arguments
   */
  directCall(network, address, type, method, arg = []) {
    return this.request({
      url: `/contracts/direct/${network}/${address}/call/${method}`,
      params: {
        type,
        arg: arg
      }
    }).then(response => response.data.data);
  }
  allEvents(contractId, fromBlock, filter = {}) {
    let params = Object.assign({}, filter);
    if (fromBlock) {
      params.fromBlock = fromBlock;
    }
    return this.request({
      url: `/contracts/${contractId}/events`,
      params
    }).then(response => response.data.data);
  }
  events(contractId, event, fromBlock, filter = {}) {
    let params = Object.assign({}, filter);
    if (fromBlock) {
      params.fromBlock = fromBlock;
    }
    return this.request({
      url: `/contracts/${contractId}/events/${event}`,
      params
    }).then(response => response.data.data);
  }
}
exports.default = Contracts;
//# sourceMappingURL=Contracts.js.map